export default __webpack_public_path__ + "static/1_travelling_to_bali_guide-68d526a604c58626a8757e5231e7d4ef.jpg";